import { styled } from "styled-components";

import { RichText } from "@atlassiansox/bxp-content-framework";

import { UiTextBlockModel } from "../../models";
import { blockquoteCSS, getOrderedListCSS, getTextSizeCSS } from "../../styles";

export type UiTextBlockProps = {
    readonly model: UiTextBlockModel;
};

const UiTextBlock = ({ model }: UiTextBlockProps) => {
    const { text, textSize, orderedListAppearance } = model.content;
    return (
        <TextBlock
            textSize={textSize}
            orderedListAppearance={orderedListAppearance}
        >
            <RichText document={text} />
        </TextBlock>
    );
};

export type TextBlockProps = {
    textSize: UiTextBlockModel["content"]["textSize"];
    orderedListAppearance: UiTextBlockModel["content"]["orderedListAppearance"];
};

export const TextBlock = styled.div<TextBlockProps>(
    ({ textSize }) => getTextSizeCSS(textSize),
    ({ orderedListAppearance }) => getOrderedListCSS(orderedListAppearance),
    blockquoteCSS
);

export default UiTextBlock;
